export const HTTP_PROTOCOL = 'http:';

export const HTTPS_PROTOCOL = 'https:';

export const HTTP_PROTOCOL_PREFIX = 'http://';

export const HTTPS_PROTOCOL_PREFIX = 'https://';

export const DEFAULT_URL_PROTOCOL_PREFIX = HTTPS_PROTOCOL_PREFIX;

export const URL_PROTOCOL_SEPARATOR = '://';

export const UNSAFE_URL_SUBSTRINGS = ['javascript:', 'data:'];

export const MIN_HOSTNAME_LENGTH = 1;
